import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';

import cx from 'classnames';

import { Arrow } from '../Arrow/Arrow';

import s from './PlayfulNavigation.module.css';

type NavItemProps = {
  children: React.ReactNode;
  highlighted?: boolean;
  href: string;
  newTab?: boolean;
  onClick?: () => void;
};

export const PlayfulNavItem = ({
  children,
  highlighted,
  href,
  newTab,
  onClick,
}: NavItemProps) => {
  const { route } = useRouter();

  const isCurrent = route === href;

  const linkClassNames = cx(s.navItem, { [s.highlighted]: highlighted });

  const linkContent = (
    <>
      {children}
      {isCurrent ? (
        <span className={s.navItemCurrentA11yHidden}>
          {' -  Current location'}
        </span>
      ) : null}
      {isCurrent || highlighted ? (
        <div className={s.activeArrow}>
          <Arrow />
        </div>
      ) : null}
    </>
  );

  if (newTab) {
    return (
      <a
        href={href}
        className={linkClassNames}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
      >
        {linkContent}
      </a>
    );
  }

  return (
    <Link href={href} onClick={onClick} className={linkClassNames}>
      {linkContent}
    </Link>
  );
};
